import { useSelector } from 'react-redux';
import { getBonusCodeData } from '../selectors';

export const useGetBonusCodeData = () => ({
  isLoading: useSelector(getBonusCodeData),
});
